import { Divider } from '@mui/material';
import { FaEnvelope, FaHome } from 'react-icons/fa';
import MenuLink from '~/components/layouts/MenuLink';
import { useCommonAppContext } from '~/shared/contexts/CommonAppContext';
import { getLcn } from '~/utils/labeled-classnames';

const startsWith = (path: string) => window.location.pathname.startsWith(path);

export default function SidebarContent() {
  const lcn = getLcn({
    sidebarContent: 'md:my-4 flex flex-col ',
  });

  return (
    <div className={lcn.sidebarContent}>

      <MenuLink to={`/`} icon={<FaHome />} > Home </MenuLink>
      <MenuLink to={`/pages/contact`} icon={<FaEnvelope />} > Contact </MenuLink>

      <Divider />

    </div>
  );
}; 